import styled from 'styled-components';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  justifyItems: 'start',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.colors.neutral['200']}`,
  width: '100%',
  position: 'sticky',
  top: 0,
  background: theme.colors.bg,
  zIndex: 1,
}));
